"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventListener = void 0;
const react_1 = require("react");
function useEventListener(eventName, callback, element = window) {
    const savedCallback = (0, react_1.useRef)(undefined);
    const savedElement = (0, react_1.useRef)(element);
    const savedEventListener = (0, react_1.useRef)((event) => savedCallback.current(event));
    const removeListener = () => {
        savedElement.current.removeEventListener(eventName, savedEventListener.current);
    };
    const addListener = () => {
        savedElement.current.addEventListener(eventName, savedEventListener.current);
    };
    (0, react_1.useEffect)(() => {
        removeListener();
        savedElement.current = element;
        savedCallback.current = callback;
        addListener();
    }, [element, callback]);
    (0, react_1.useEffect)(() => {
        return () => {
            removeListener();
        };
    }, []);
}
exports.useEventListener = useEventListener;
//# sourceMappingURL=useEventListener.js.map